module.exports = __webpack_public_path__ + "3aa0a6c82f6236b2a310024a3ad3613c.svg";